import React, { useState, useEffect } from 'react';
import OfferDisplayStatusConst from '../../common/variables/OfferDisplayStatusConst';
import {getTaxPrice, getTaxFromSettings,dateTimePrint} from '../../common/methods/CommonUtil';
import { useTranslation,Trans } from "react-i18next";

function OfferDetailInfo(props) {
	const { t } = useTranslation();

	const datepet = new Date(props.purchase_end_time);
	const archiveDateepet = new Date(props.archive_purchase_end_time)
	const [tax, setTax] = useState(1)
	
	useEffect(() => {
		getTax();
	}, [props.settingJson])

	const getTax = () => {
		if (!props.settingJson) {return;}
		let tax = getTaxFromSettings(props.settingJson);
		if (tax) {setTax(tax);}
	}

	const [browsers0, setBrowser0] = useState('');
	const [browsers1, setBrowser1] = useState('');
	const [browsers2, setBrowser2] = useState('');
	const [browsers3, setBrowser3] = useState('');

	useEffect(() => {
		setBrowserInfo();
	}, [props.language]);

	const setBrowserInfo = () => {
		setBrowser0(getBrowserList('recommendBrowser.deviceList.pc.devices.0.browser'));
		setBrowser1(getBrowserList('recommendBrowser.deviceList.pc.devices.1.browser'));
		setBrowser2(getBrowserList('recommendBrowser.deviceList.mobile.devices.0.browser'));
		setBrowser3(getBrowserList('recommendBrowser.deviceList.mobile.devices.1.browser'));
	}

	const getBrowserList = (str) => {
		//存在有無の確認
		let ret = t(str, { returnObjects: true });
		if(ret === str) {
			ret = null;
		}
		return ret;
	}

	return (
		<dl className="detail-info">
			{ !props.is_ensemble_cancelled ?(
				<>
				{props.display_status === OfferDisplayStatusConst.archive ?
					<>
					<dt className="detail-info__title before-live-only">{t('offer.price')}</dt>
					<dd className="detail-info__text before-live-only">{getTaxPrice(props.isJapan, props.archivePianoPrice, tax)}{t('offer.yen')}</dd>
					<dt className="detail-info__title before-live-only">{t('offer.purchasedPeriod')}</dt>
					<dd className="detail-info__text before-live-only">{dateTimePrint(props.language, archiveDateepet , "MMDD/")}</dd>
					</>
				:
					<>
					<dt className="detail-info__title before-live-only">{t('offer.price')}</dt>
					<dd className="detail-info__text before-live-only">{getTaxPrice(props.isJapan, props.pianoPrice, tax)}{t('offer.yen')}</dd><br/>
					<dt className="detail-info__title before-live-only">{t('offer.purchasedPeriod')}</dt>
					<dd className="detail-info__text before-live-only">{dateTimePrint(props.language, datepet , "MMDD/")}</dd>
					<br/>
					</>
				}
				</>
			) : (
				<>
					<dt className="detail-info__title before-live-only">{t('offer.price')}</dt>
					<dd className="detail-info__text before-live-only">{t('ticketStatus.cancelled')}</dd>
					<br/><br/>
				</>
			)}

			<br/><br/>
			<dt></dt>
			<>
			<dd className="detail-info__text">
			<div><Trans i18nKey="recommendBrowser.confirmLink" components={{ l: <a href={t('recommendBrowser.confirmLinkURL')}>link</a> }}/></div>
			</dd>
			<br/><br/>
			<dt className="detail-info__text-title">{t('recommendBrowser.title')}</dt>
			<dd className="detail-info__text">
				<div>
					<div className="detail-info__text-title">{t('recommendBrowser.deviceList.pc.title')}</div>
					{browsers0 && (
						<>
						<div className="detail-info__text-title">{t('recommendBrowser.deviceList.pc.devices.0.title')}</div>
						{browsers0.map((browser, index) => {
							return (<p key={index}>・{browser}</p>)
						})}
						</>
					)}
					{browsers1 && (
						<>
						<div className="detail-info__text-title">{t('recommendBrowser.deviceList.pc.devices.1.title')}</div>
						{browsers1.map((browser, index) => {
							return (<p key={index}>・{browser}</p>)
						})}
						</>
					)}
					<div className="detail-info__text-title">{t('recommendBrowser.deviceList.mobile.title')}</div>
					{browsers2 && (
						<>
						<div className="detail-info__text-title">{t('recommendBrowser.deviceList.mobile.devices.0.title')}</div>
						{browsers2.map((browser, index) => {
							return (<p key={index}>・{browser}</p>)
						})}
						</>
					)}
					{browsers3 && (
						<>
						<div className="detail-info__text-title">{t('recommendBrowser.deviceList.mobile.devices.1.title')}</div>
						{browsers3.map((browser, index) => {
							return (<p key={index}>・{browser}</p>)
						})}
						</>
					)}
				</div>
			</dd>
			</>
		</dl>
	);

}

export default OfferDetailInfo;